import React, { ReactNode, useState } from "react";
import classNames from "classnames";
import { useIsOverflow } from "hooks/useIsOverflow";

interface IViewMoreSectionProps {
    children: ReactNode;
}
const ViewMoreSection = ({ children }: IViewMoreSectionProps) => {
    const { ref, isOverflow } = useIsOverflow();

    const [isOpen, setIsOpen] = useState(false);
    const toggle = () => setIsOpen(!isOpen);

    const rootClasses = classNames({
        "view-more-section": true,
        "no-shadow": !isOverflow || isOpen,
        open: isOpen
    });
    const arrowClasses = classNames({
        "arrow-icon": isOverflow || isOpen,
        "arrow-icon-down": !isOpen,
        "arrow-icon-up": isOpen
    });

    return (
        <>
            <div className={rootClasses} ref={ref}>
                {children}
            </div>
            <button
                type="button"
                className="view-more-btn"
                onClick={toggle}
                aria-label={`${isOpen ? "Vis mindre" : "Vis mere"}`}
                aria-expanded={isOpen}
            >
                <div className={arrowClasses}></div>
            </button>
        </>
    );
};

export default ViewMoreSection;
